// extracted by css-extract-rspack-plugin
export default {"markdown-content":"Markdown_markdown-content__8KSR-","anchor":"Markdown_anchor__bDxUl"};